import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { BannerContainer, BannerSectionContainer, ButtonLabel } from "@similarweb/ui-components";

export const CampaignsBannerWrapper = styled.div`
    width: 100%;
    ${BannerContainer} {
        height: 56px;
        padding: 12px 12px 12px 16px;
        box-sizing: border-box;
        box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
        ${BannerSectionContainer} {
            &:first-child .SWReactIcons svg path {
                fill: ${colorsPalettes.carbon[300]};
            }
            &:last-child {
                ${ButtonLabel} {
                    font-weight: 700;
                    color: ${colorsPalettes.indigo[300]};
                }
                .SWReactIcons svg path {
                    fill: ${colorsPalettes.indigo[300]};
                }
            }
            &:last-child:hover {
                ${ButtonLabel} {
                    color: ${colorsPalettes.indigo[400]};
                }
                .SWReactIcons svg path {
                    fill: ${colorsPalettes.indigo[400]};
                }
            }
            p {
                &:first-child {
                    ${setFontVariant("subtitle1", colorsPalettes.carbon[400])};
                }
                &:last-child {
                    ${setFontVariant("body1", colorsPalettes.carbon[400])};
                }
            }
        }
    }
`;
